var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g3, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g4, _path64, _path65, _path66, _ellipse4, _g5, _ellipse5, _path67, _path68, _path69, _path70, _path71, _path72, _ellipse6, _path73, _path74, _path75, _path76, _path77, _g6, _circle, _rect, _rect2, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _rect3, _rect4, _path86, _ellipse7, _ellipse8, _path87, _g7, _circle2, _path88, _path89, _path90, _path91, _g8, _path92, _path93, _path94, _path95, _path96, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg08IntroOnboard01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 430,
    viewBox: "0 0 302 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 279.147,
    rx: 151,
    ry: 150.853,
    fill: "#F19239"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 279.147,
    rx: 151,
    ry: 150.853,
    fill: "#FAACDA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3141_12046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 128,
    width: 302,
    height: 302
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 279.147,
    rx: 151,
    ry: 150.853,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3141_12046)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9371 410.461V421.919C85.9371 429.055 122.027 441.371 147.867 441.361C173.497 441.361 199.627 440.942 217.707 424.404C217.707 424.404 221.097 417.657 219.587 409.942L203.397 419.513L169.347 424.394L119.187 417.627L94.8471 414.244L85.9371 410.441V410.461Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.267 299.098C242.704 299.098 252.787 289.035 252.787 276.622C252.787 264.209 242.704 254.146 230.267 254.146C217.83 254.146 207.747 264.209 207.747 276.622C207.747 289.035 217.83 299.098 230.267 299.098Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.217 237.319C222.997 234.804 223.227 232.049 222.747 229.254C221.177 220.002 212.657 213.735 203.727 215.242C203.667 215.252 203.607 215.272 203.537 215.282C198.487 209.124 189.827 205.79 180.747 207.327C167.797 209.513 158.907 220.771 160.887 232.468C161.007 233.187 161.167 233.895 161.367 234.594C153.657 238.337 148.547 245.622 148.297 253.597C144.687 249.225 139.247 246.291 133.137 245.523C132.027 238.995 127.657 232.927 120.927 229.664C110.237 224.494 97.637 228.366 92.807 238.327C90.297 243.497 90.387 249.275 92.527 254.365C82.457 258.278 76.097 268.019 77.807 278.089C79.787 289.786 91.897 297.491 104.847 295.305C111.007 294.268 116.247 291.164 119.837 286.942C123.767 288.349 128.197 288.798 132.737 288.04C144.237 286.093 152.537 276.991 152.857 266.791C157.917 272.919 166.557 276.233 175.607 274.696C181.317 273.728 186.237 271.003 189.787 267.25C194.387 274.965 204.087 279.416 214.317 277.68C227.267 275.494 231.947 264.196 234.177 252.539C235.977 243.117 230.477 237.269 222.217 237.329V237.319Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.217 237.319C222.997 234.804 223.227 232.049 222.747 229.254C221.177 220.002 212.657 213.735 203.727 215.242C203.667 215.252 203.607 215.272 203.537 215.282C198.487 209.124 189.827 205.79 180.747 207.327C167.797 209.513 158.907 220.771 160.887 232.468C161.007 233.187 161.167 233.895 161.367 234.594C153.657 238.337 148.547 245.622 148.297 253.597C144.687 249.225 139.247 246.291 133.137 245.523C132.027 238.995 127.657 232.927 120.927 229.664C110.237 224.494 97.637 228.366 92.807 238.327C90.297 243.497 90.387 249.275 92.527 254.365C82.457 258.278 76.097 268.019 77.807 278.089C79.787 289.786 91.897 297.491 104.847 295.305C111.007 294.268 116.247 291.164 119.837 286.942C123.767 288.349 128.197 288.798 132.737 288.04C144.237 286.093 152.537 276.991 152.857 266.791C157.917 272.919 166.557 276.233 175.607 274.696C181.317 273.728 186.237 271.003 189.787 267.25C194.387 274.965 204.087 279.416 214.317 277.68C227.267 275.494 231.947 264.196 234.177 252.539C235.977 243.117 230.477 237.269 222.217 237.329V237.319Z",
    fill: "url(#paint0_linear_3141_12046)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.926 248.474C128.182 246.407 130.953 240.956 129.114 236.299C127.275 231.643 121.523 229.544 116.267 231.612C111.011 233.679 108.24 239.13 110.079 243.787C111.917 248.443 117.669 250.542 122.926 248.474Z",
    fill: "#CB6C66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.357 250.553V272.909C140.357 272.909 149.297 279.576 161.437 273.618V250.553H140.357Z",
    fill: "#CB6C66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.627 416.809C197.287 441.93 111.047 439.654 88.1671 416.809C67.5465 389.253 85.8399 326.044 85.8399 326.044C85.8399 291.122 105.457 266.991 140.457 266.991L141.337 267.54C147.617 271.472 155.707 270.973 161.447 266.283C196.437 266.283 217.637 291.633 217.637 326.555C217.637 326.555 231.847 399.253 217.637 416.799L217.627 416.809Z",
    fill: "#6537C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.606 422.916C206.027 415.696 206.836 404.935 206.813 400.457L223.768 393.77C223.214 403.476 221.555 409.927 220.122 414.235L202.606 422.916Z",
    fill: "url(#paint1_linear_3141_12046)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.483 403.488C156.907 405.842 158.945 410.93 163.711 412.454C169.668 414.359 173.11 410.233 175.837 403.488",
    stroke: "#4B239F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.83 408.302C108.906 406.34 107.674 401.803 107.924 399.779C115.4 399.156 127.408 397.477 131.603 397.577C135.797 397.676 134.821 400.944 133.808 402.566L125.527 407.221C124.126 408.011 120.225 409.333 115.83 408.302Z",
    fill: "#4B239F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.376 406.488C190.3 404.526 191.532 399.988 191.283 397.965C183.806 397.341 171.798 395.663 167.604 395.763C163.409 395.862 164.385 399.13 165.398 400.751L173.679 405.407C175.08 406.197 178.981 407.519 183.376 406.488Z",
    fill: "#4B239F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0325 267.827C81.3379 263.139 88.102 253.942 96.7154 254.657",
    stroke: "black",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.417 403.356C96.6941 406.44 85.0944 402.822 81.7759 401.876C81.2468 396.314 81.6595 395.641 81.7759 393.082C85.6175 396.641 97.2604 399.923 108.552 399.662L113.417 403.356Z",
    fill: "#4B239F"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1671 416.809L88.5204 416.455L88.5203 416.455L88.1671 416.809ZM81.2777 339.047C81.3157 338.774 81.1248 338.521 80.8512 338.483C80.5777 338.445 80.3252 338.636 80.2872 338.91L81.2777 339.047ZM217.238 416.494C212.254 422.65 203.176 427.183 191.909 430.136C180.659 433.084 167.303 434.438 153.855 434.296C140.408 434.154 126.888 432.517 115.314 429.496C103.724 426.47 94.1468 422.073 88.5204 416.455L87.8138 417.163C93.6274 422.967 103.41 427.422 115.061 430.463C126.727 433.508 140.329 435.154 153.844 435.296C167.359 435.439 180.807 434.079 192.162 431.103C203.501 428.131 212.83 423.528 218.016 417.123L217.238 416.494ZM88.5203 416.455C84.6391 412.581 82.2014 405.854 80.7639 397.831C79.3302 389.83 78.9067 380.634 78.9823 371.917C79.0578 363.203 79.6317 354.984 80.187 348.942C80.4646 345.922 80.7375 343.447 80.9409 341.727C81.0426 340.868 81.1269 340.197 81.1857 339.741C81.2151 339.514 81.2382 339.34 81.2538 339.223C81.2617 339.165 81.2677 339.12 81.2717 339.091C81.2737 339.076 81.2752 339.065 81.2762 339.058C81.2767 339.054 81.2771 339.052 81.2773 339.05C81.2775 339.049 81.2776 339.048 81.2776 339.048C81.2777 339.047 81.2777 339.047 80.7825 338.978C80.2872 338.91 80.2872 338.91 80.2871 338.91C80.287 338.911 80.2869 338.912 80.2868 338.913C80.2865 338.915 80.2861 338.918 80.2856 338.921C80.2845 338.929 80.2829 338.941 80.2809 338.956C80.2768 338.986 80.2707 339.031 80.2627 339.09C80.2468 339.208 80.2236 339.384 80.1939 339.613C80.1347 340.072 80.0499 340.746 79.9478 341.61C79.7435 343.337 79.4697 345.821 79.1912 348.851C78.6343 354.91 78.0581 363.158 77.9823 371.908C77.9065 380.655 78.3304 389.92 79.7795 398.008C81.2248 406.073 83.7052 413.062 87.8139 417.163L88.5203 416.455Z",
    fill: "#18161B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.447 266.991C140.447 266.991 49.0171 261.831 40.0971 333.032C31.1771 404.233 109.187 401.978 109.187 401.978L105.337 380.939C105.337 380.939 76.4571 363.662 85.2071 336.655C85.2071 336.655 94.0971 320.257 117.177 326.455",
    fill: "#6537C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.447 266.991C140.447 266.991 49.0171 261.831 40.0971 333.032C31.1771 404.233 109.187 401.978 109.187 401.978L105.337 380.939C105.337 380.939 76.4571 363.662 85.2071 336.655C85.2071 336.655 94.0971 320.257 117.177 326.455",
    fill: "url(#paint2_linear_3141_12046)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.157 318.84C96.6571 321.345 91.4371 326.415 88.4071 330.607C85.8371 334.18 84.2671 338.382 83.7771 342.753C80.9271 368.024 105.337 380.929 105.337 380.929L109.187 401.968C109.187 401.968 31.1771 404.233 40.0971 333.032C48.6971 264.386 133.907 266.442 140.007 266.682C140.217 266.682 140.417 266.771 140.577 266.911C141.417 267.65 144.597 270.105 150.307 270.185",
    stroke: "#18161B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.534 402.039C197.256 405.123 219.858 399.291 223.177 398.345C223.767 392.725 223.966 392.703 223.85 390.144C220.008 393.703 196.69 398.606 185.398 398.345L180.534 402.039Z",
    fill: "url(#paint3_linear_3141_12046)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.575 257.451C217.345 257.603 217.281 257.913 217.434 258.144C217.586 258.374 217.896 258.437 218.126 258.285L217.575 257.451ZM252.287 276.622C252.287 288.758 242.429 298.598 230.267 298.598V299.598C242.98 299.598 253.287 289.312 253.287 276.622H252.287ZM230.267 254.646C242.429 254.646 252.287 264.486 252.287 276.622H253.287C253.287 263.932 242.98 253.646 230.267 253.646V254.646ZM218.126 258.285C221.607 255.985 225.779 254.646 230.267 254.646V253.646C225.577 253.646 221.214 255.046 217.575 257.451L218.126 258.285Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.213 345.862C214.85 336.116 206.655 323.988 202.026 317.476C204.199 315.729 210.599 313.2 218.819 317.051C229.093 321.865 236.25 342.818 230.44 358.817C225.791 371.615 207.765 378.638 199.333 380.549C212.938 357.188 213.725 353.331 214.213 345.862Z",
    fill: "#4B239F"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.437 266.292C161.437 266.292 253.721 257.415 261.697 329.639C270.617 400.84 184.407 401.05 184.407 401.05L197.094 377.361C197.094 377.361 229.237 362.041 218.089 333.603C218.089 333.603 207.4 312.135 184.33 318.343",
    fill: "#6537C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.437 266.292C161.437 266.292 253.721 257.415 261.697 329.639C270.617 400.84 184.407 401.05 184.407 401.05L197.094 377.361C197.094 377.361 229.237 362.041 218.089 333.603C218.089 333.603 207.4 312.135 184.33 318.343",
    fill: "url(#paint4_linear_3141_12046)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.437 265.913C161.437 265.913 256.687 259.546 262.177 331.096C267.607 401.888 185.935 400.58 185.935 400.58L194.757 378.314C194.757 378.314 223.027 366.108 220.167 340.837C219.677 336.466 218.107 332.264 215.537 328.691C212.507 324.489 205.617 319.429 197.117 316.924",
    stroke: "#18161B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.107 235.303C116.107 235.303 114.427 236.57 113.537 238.606C112.917 240.004 112.667 241.77 113.587 243.717",
    stroke: "#18161B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M162.901 321.615C162.901 321.615 176.044 307.842 185.493 269.453",
    stroke: "#4B239F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.95 366.04C179.95 366.04 173.595 334.257 156.212 314.889",
    stroke: "#4B239F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.527 238.607C113.527 238.607 118.757 239.096 119.177 244.236",
    stroke: "#18161B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.381 249.727C119.381 249.727 134.557 291.413 162.947 322.562C190.987 353.332 179.631 408.874 167.767 409.932C160.407 410.291 155.897 401.987 155.897 401.987",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M160.157 319.419C160.157 319.419 188.987 287.002 190.617 233.826",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.627 240.822C121.627 238.766 119.957 237.099 117.897 237.099C115.837 237.099 114.167 238.766 114.167 240.822C114.167 241.76 114.527 242.608 115.097 243.267C115.767 245.313 117.057 248.577 118.807 249.954L120.027 249.575C120.027 249.575 118.757 246.541 118.627 244.475C120.337 244.136 121.627 242.628 121.627 240.822Z",
    fill: "#F2F2F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.234 247.551C118.035 246.338 117.608 244.982 117.571 244.455C117.933 244.651 118.402 244.69 118.637 244.702C118.599 244.884 118.84 246.408 119.234 247.551Z",
    fill: "#DDDDDD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.65 253.474C182.752 249.739 198.156 231.895 195.056 213.618C191.955 195.341 171.524 183.552 149.421 187.287C127.319 191.023 111.914 208.867 115.015 227.144C118.116 245.421 138.547 257.21 160.65 253.474Z",
    fill: "#CB6C66"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.517 209.813L187.627 216.36C188.117 219.224 186.177 221.939 183.307 222.428C180.437 222.917 177.717 220.981 177.227 218.116L176.117 211.569",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.16 241.753C148.558 239.658 159.304 223.507 157.32 211.812C155.336 200.116 142.181 197.443 129.784 199.538C117.386 201.633 107.011 209.043 108.996 220.739C110.98 232.434 123.763 243.848 136.16 241.753Z",
    fill: "#993F39",
    fillOpacity: 0.92
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.83 254.458C149.929 254.865 143.017 253.84 140.364 253.296L140.364 261.053C144.899 260.56 152.608 256.431 155.83 254.458Z",
    fill: "#993F39"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.517 216.959L165.627 223.506C166.117 226.37 164.177 229.085 161.307 229.574C158.437 230.063 155.717 228.127 155.227 225.263L154.117 218.715",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.632 204.601C179.025 202.502 163.568 212.073 157.415 217.12L154.038 211.198C160.892 207.9 176.309 201.243 183.152 201.003C189.996 200.763 191.657 203.302 191.632 204.601Z",
    fill: "#9D433D"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.787 245.952C126.787 245.952 134.081 254.643 155.547 254.139",
    stroke: "#18161B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 239.371C147.6 237.183 152.79 225.033 157.136 215.465C161.483 205.897 184.532 189.388 171.583 191.576C158.634 193.764 108.214 212.396 110.097 223.498C111.981 234.6 121.702 241.559 134.651 239.371Z",
    fill: "#1F1F1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 239.371C147.6 237.183 152.79 225.033 157.136 215.465C161.483 205.897 184.532 189.388 171.583 191.576C158.634 193.764 108.214 212.396 110.097 223.498C111.981 234.6 121.702 241.559 134.651 239.371Z",
    fill: "url(#paint5_linear_3141_12046)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.121 170.825C145.786 160.924 175.174 164.279 185.237 187.107L185.227 187.097L128.667 225.622L111.059 227.784C102.922 206.152 106.407 188.784 122.717 174.601C123.598 173.835 124.534 173.114 125.518 172.44C125.376 172.302 125.241 172.147 125.117 171.977C124.302 170.871 124.22 169.551 124.932 169.029C125.644 168.507 126.881 168.98 127.696 170.086C127.872 170.326 128.014 170.576 128.121 170.825Z",
    fill: "#5C32D2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.121 170.825C145.786 160.924 175.174 164.279 185.237 187.107L185.227 187.097L128.667 225.622L111.059 227.784C102.922 206.152 106.407 188.784 122.717 174.601C123.598 173.835 124.534 173.114 125.518 172.44C125.376 172.302 125.241 172.147 125.117 171.977C124.302 170.871 124.22 169.551 124.932 169.029C125.644 168.507 126.881 168.98 127.696 170.086C127.872 170.326 128.014 170.576 128.121 170.825Z",
    fill: "url(#paint6_linear_3141_12046)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 196.985C158.511 184.079 177.35 184.763 184.866 186.718C181.695 187.325 174.707 188.584 172.123 188.772C168.894 189.006 159.439 192.115 146.579 198.275C136.29 203.203 130.156 218.711 128.374 225.849C127.004 221.605 128.069 209.892 143.29 196.985Z",
    fill: "#311B70"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M145.217 219.244C145.217 219.244 155.137 209.663 174.437 203.545C179.047 202.447 183.297 201.559 186.697 201.908C190.097 202.257 192.747 204.832 193.317 208.156L193.687 208.445C193.687 208.445 204.447 205.421 205.707 202.976C206.967 200.531 206.547 198.275 204.627 196.628C201.017 193.524 187.467 191.997 187.467 191.997C187.467 191.997 172.047 193.075 168.157 194.353C164.267 195.63 158.427 198.046 156.617 200.022C154.807 201.998 143.557 207.707 143.467 211.439C143.377 215.172 143.037 219.893 143.037 219.893L145.217 219.234V219.244Z",
    fill: "#20115F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M145.217 219.244C145.217 219.244 155.137 209.663 174.437 203.545C179.047 202.447 183.297 201.559 186.697 201.908C190.097 202.257 192.747 204.832 193.317 208.156L193.687 208.445C193.687 208.445 204.447 205.421 205.707 202.976C206.967 200.531 206.547 198.275 204.627 196.628C201.017 193.524 187.467 191.997 187.467 191.997C187.467 191.997 172.047 193.075 168.157 194.353C164.267 195.63 158.427 198.046 156.617 200.022C154.807 201.998 143.557 207.707 143.467 211.439C143.377 215.172 143.037 219.893 143.037 219.893L145.217 219.234V219.244Z",
    fill: "url(#paint7_linear_3141_12046)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M128.627 225.652C128.627 225.652 137.927 229.091 142.657 222.807C147.097 216.909 147.037 208.236 157.657 200.93C164.597 196.149 174.457 191.987 192.987 193.574C194.974 193.816 196.777 194.183 198.547 194.872C204.517 197.207 206.757 199.433 205.287 202.058C203.607 205.072 193.617 208.395 193.617 208.395L194.237 210.162C194.237 210.162 204.237 207.158 207.267 204.743C210.297 202.327 211.577 198.624 207.477 194.702C204.357 191.728 194.877 185.111 178.567 186.917C162.267 188.724 149.447 193.075 138.817 204.114C128.187 215.152 128.627 225.652 128.627 225.652Z",
    fill: "#9B8DF2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M128.627 225.652C128.627 225.652 137.927 229.091 142.657 222.807C147.097 216.909 147.037 208.236 157.657 200.93C164.597 196.149 174.457 191.987 192.987 193.574C194.974 193.816 196.777 194.183 198.547 194.872C204.517 197.207 206.757 199.433 205.287 202.058C203.607 205.072 193.617 208.395 193.617 208.395L194.237 210.162C194.237 210.162 204.237 207.158 207.267 204.743C210.297 202.327 211.577 198.624 207.477 194.702C204.357 191.728 194.877 185.111 178.567 186.917C162.267 188.724 149.447 193.075 138.817 204.114C128.187 215.152 128.627 225.652 128.627 225.652Z",
    fill: "url(#paint8_linear_3141_12046)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 346.246L174.687 403.175L130.087 402.936L122.067 346.007L166.667 346.246Z",
    fill: "#C2BECF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 346.246L174.687 403.175L130.087 402.936L122.067 346.007L166.667 346.246Z",
    fill: "url(#paint9_linear_3141_12046)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 346.247L167.637 340.857L175.657 397.796L174.687 403.176L166.667 346.247Z",
    fill: "#806FBB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 346.247L167.637 340.857L175.657 397.796L174.687 403.176L166.667 346.247Z",
    fill: "url(#paint10_linear_3141_12046)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.067 346.007L123.037 340.617L167.637 340.857L166.667 346.247L122.067 346.007Z",
    fill: "#CAC3E1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M122.067 346.007L123.037 340.617L167.637 340.857L166.667 346.247L122.067 346.007Z",
    fill: "url(#paint11_linear_3141_12046)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.867 392.316L135.027 392.266C137.707 391.478 139.247 388.673 138.457 385.999C137.677 383.344 134.897 381.817 132.237 382.565C134.887 381.757 136.397 378.972 135.617 376.317C134.827 373.643 132.017 372.106 129.337 372.894L128.297 373.204C130.417 372.235 131.407 369.77 130.517 367.604L129.987 366.317C129.067 364.091 126.517 363.023 124.287 363.942L114.407 367.984C113.387 368.024 112.357 368.163 111.337 368.463C104.757 370.389 100.987 377.276 102.917 383.843L107.077 397.995C109.007 404.562 115.907 408.325 122.487 406.399C123.807 406.01 125.017 405.411 126.087 404.672L135.027 402.057C137.707 401.269 139.247 398.464 138.457 395.789C137.937 394.023 136.527 392.765 134.867 392.336V392.316Z",
    fill: "#CB6C66"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.517 367.604L129.987 366.317C129.067 364.091 126.517 363.023 124.287 363.942L114.407 367.984C113.387 368.024 112.357 368.163 111.337 368.463C104.757 370.389 100.987 377.276 102.917 383.843L107.077 397.995",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.957 390.151L163.797 390.101C161.117 389.312 159.577 386.508 160.367 383.833C161.147 381.178 163.927 379.651 166.587 380.4C163.937 379.591 162.427 376.807 163.207 374.152C163.997 371.477 166.807 369.94 169.487 370.728L170.527 371.038C168.407 370.07 167.417 367.605 168.307 365.439L168.837 364.151C169.757 361.926 172.307 360.858 174.537 361.776L184.417 365.818C185.437 365.858 186.467 365.998 187.487 366.297C194.067 368.223 197.837 375.11 195.907 381.677L191.747 395.829C189.817 402.397 182.917 406.159 176.337 404.233C175.017 403.844 173.807 403.245 172.737 402.506L163.797 399.892C161.117 399.103 159.577 396.299 160.367 393.624C160.887 391.857 162.297 390.6 163.957 390.17V390.151Z",
    fill: "#CB6C66"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M116.614 373.069C119.223 378.569 124.662 391.536 125.545 399.403",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M183.282 371.085C180.673 376.585 175.235 389.552 174.351 397.419",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.239 365.843L168.769 364.555C169.689 362.33 172.239 361.262 174.469 362.18L184.349 366.222C185.369 366.262 186.399 366.402 187.419 366.701C193.999 368.627 197.769 375.514 195.839 382.081L191.679 396.234",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.272 371.528C169.168 370.587 168.632 367.889 168.07 366.664C167.829 367.219 167.828 368.677 168.945 370.149C170.202 371.804 171.817 371.58 173.272 371.528Z",
    fill: "#A3504B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M125.605 373.856C129.709 372.914 130.245 370.217 130.807 368.992C131.048 369.546 131.049 371.005 129.932 372.477C128.675 374.132 127.06 373.908 125.605 373.856Z",
    fill: "#A3504B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M167.36 380.766C164.14 379.057 163.61 376.47 163.047 375.245C162.993 375.83 162.814 377.36 163.932 378.832C165.188 380.487 166.654 380.86 167.36 380.766Z",
    fill: "#A3504B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M164.508 390.513C161.288 388.804 160.757 386.217 160.195 384.991C160.14 385.577 159.962 387.106 161.079 388.578C162.336 390.233 163.802 390.607 164.508 390.513Z",
    fill: "#A3504B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M131.517 383.094C134.736 381.385 135.267 378.798 135.829 377.573C135.884 378.158 136.063 379.687 134.945 381.159C133.689 382.815 132.223 383.188 131.517 383.094Z",
    fill: "#A3504B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M134.352 392.632C137.572 390.923 138.103 388.336 138.665 387.111C138.72 387.696 138.898 389.225 137.781 390.697C136.524 392.352 135.058 392.726 134.352 392.632Z",
    fill: "#A3504B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3141_12046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 360,
    width: 13,
    height: 10
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.187 360.255H140.187V369.237H152.187V360.255Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.187 360.255C142.871 360.255 140.187 362.265 140.187 364.746C140.187 367.227 142.871 369.237 146.187 369.237C149.503 369.237 152.187 367.227 152.187 364.746C152.187 362.265 149.503 360.255 146.187 360.255Z",
    fill: "#817796"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.187 359.533C146.541 358.399 147.533 357.431 149.187 357.6C148.876 358.305 147.799 359.866 146.187 359.533Z",
    fill: "#817796"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M231.896 240.858C231.707 240.657 231.39 240.647 231.189 240.836C230.988 241.025 230.978 241.341 231.167 241.543L231.896 240.858ZM234.271 254.491C235.447 252.024 236.607 245.872 231.896 240.858L231.167 241.543C235.5 246.155 234.435 251.822 233.368 254.061L234.271 254.491Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8453 254.993C90.6561 250.781 88.4675 240.398 97.2267 232.565C101.022 229.505 105.527 227.625 111.266 227.669",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.394,
    cy: 239.895,
    rx: 0.989502,
    ry: 0.988538,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1618 153.272C94.2764 153.093 94.4459 152.954 94.644 152.876C107.761 147.66 117.033 134.85 117.033 119.875C117.033 100.269 101.139 84.3753 81.533 84.3753C61.9269 84.3753 46.033 100.269 46.033 119.875C46.033 134.838 55.29 147.639 68.3895 152.863C68.5872 152.942 68.7564 153.08 68.8708 153.259L79.8342 170.45C80.6204 171.683 82.4206 171.683 83.2068 170.45L94.1618 153.272Z",
    fill: "#5746C0"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.7363,
    cy: 120.092,
    rx: 30.9891,
    ry: 31,
    fill: "#1A113C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5299 112.74H69.0304L72.4753 136.001C72.5479 136.491 72.9688 136.854 73.4645 136.854H81.5299V112.74ZM81.5299 112.74H94.0294L90.5845 136.001C90.5119 136.491 90.091 136.855 89.5953 136.855H81.5299V112.74Z",
    fill: "#D9D9D9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5699 102.915H81.5297V102.916H72.4897C72.0308 102.916 71.6308 103.228 71.5195 103.673L70.816 106.488H68.8803C68.374 106.488 67.9475 106.867 67.8874 107.369L67.3786 111.621C67.3074 112.216 67.7722 112.74 68.3716 112.74H81.5299V112.74H94.688C95.2874 112.74 95.7521 112.216 95.6809 111.621L95.1722 107.369C95.112 106.866 94.6856 106.488 94.1792 106.488H92.2435L91.54 103.673C91.4288 103.228 91.0287 102.915 90.5699 102.915Z",
    fill: "#4841A6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5297 112.74H69.0302L72.4751 136.001C72.5477 136.491 72.9686 136.855 73.4643 136.855H81.5297V112.74ZM81.5297 112.74H94.0292L90.5843 136.001C90.5117 136.491 90.0908 136.855 89.5951 136.855H81.5297V112.74Z",
    fill: "#ABA9C8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5298 112.74H69.0303L72.4752 136.001C72.5478 136.491 72.9687 136.855 73.4644 136.855H81.5298V112.74ZM81.5298 112.74H90.458L87.0131 136.001C86.9405 136.491 86.5196 136.855 86.0239 136.855H81.5298V112.74Z",
    fill: "#E7E6F0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9984 102.916H81.5294V102.916H72.4894C72.0306 102.916 71.6305 103.228 71.5193 103.673L70.8158 106.488H68.88C68.3737 106.488 67.9473 106.867 67.8871 107.369L67.3784 111.621C67.3072 112.217 67.7719 112.74 68.3713 112.74H81.5297V112.74H91.1166C91.7159 112.74 92.1807 112.216 92.1095 111.621L91.6008 107.369C91.5406 106.867 91.1142 106.488 90.6078 106.488H88.672L87.9685 103.673C87.8572 103.228 87.4572 102.916 86.9984 102.916Z",
    fill: "#8F87F3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5436 106.05C81.5436 105.803 81.7436 105.604 81.9902 105.604H88.6862V106.497H81.9902C81.7436 106.497 81.5436 106.297 81.5436 106.05V106.05Z",
    fill: "#4841A6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.8364,
    cy: 123.145,
    rx: 6.24975,
    ry: 6.25194,
    fill: "#ABA9C8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1105 125.411L76.109 122.617H76.9413L76.9428 125.411C76.9428 125.64 76.7565 125.826 76.5266 125.826C76.2968 125.826 76.1105 125.64 76.1105 125.411Z",
    fill: "#E7E6F0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0522 125.411L80.0507 122.617H80.883L80.8845 125.411C80.8845 125.64 80.6982 125.826 80.4684 125.826C80.2385 125.826 80.0522 125.64 80.0522 125.411Z",
    fill: "#E7E6F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9831 125.834C79.2342 125.834 79.4377 125.63 79.4377 125.379C79.4377 125.128 79.2342 124.924 78.9831 124.924C78.732 124.924 78.5285 125.128 78.5285 125.379C78.5285 125.63 78.732 125.834 78.9831 125.834Z",
    fill: "#6B57EA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7758 120.382C78.6952 120.385 79.4367 121.133 79.4344 122.055V122.055L79.4371 122.65C79.4339 123.572 78.6874 124.316 77.7675 124.313C76.8477 124.31 76.1062 123.561 76.109 122.639L76.941 122.641C76.9397 123.1 77.3127 123.477 77.7703 123.479C78.2325 123.48 78.6037 123.106 78.6051 122.647L78.6023 122.054C78.6037 121.595 78.2307 121.218 77.7731 121.216C77.3691 121.215 77.0289 121.506 76.9537 121.89H76.1138C76.1941 121.041 76.908 120.379 77.7758 120.382Z",
    fill: "#E7E6F0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7176 120.382C82.637 120.384 83.3784 121.133 83.3761 122.055V122.055L83.3788 122.65C83.3756 123.572 82.6291 124.316 81.7092 124.313C80.7894 124.31 80.048 123.561 80.0507 122.638L80.8828 122.641C80.8814 123.1 81.2544 123.477 81.712 123.478C82.1743 123.48 82.5454 123.106 82.5468 122.647L82.544 122.053C82.5454 121.594 82.1724 121.217 81.7148 121.216C81.3108 121.215 80.9706 121.506 80.8955 121.89H80.0555C80.1358 121.041 80.8497 120.379 81.7176 120.382Z",
    fill: "#E7E6F0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.416 83.203C189.528 83.0286 189.691 82.8933 189.881 82.813C199.948 78.5698 207.014 68.6101 207.014 57C207.014 41.536 194.478 29 179.014 29C163.55 29 151.014 41.536 151.014 57C151.014 68.7371 158.236 78.7874 168.478 82.9501C168.674 83.0297 168.842 83.1669 168.955 83.3451L177.454 96.672C178.241 97.9048 180.041 97.9048 180.827 96.672L189.416 83.203Z",
    fill: "#5746C0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.014,
    cy: 56.7045,
    r: 24,
    fill: "#1A113C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168.382,
    y: 45.9012,
    width: 21.5176,
    height: 18.8096,
    rx: 1,
    fill: "#4841A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.054,
    y: 46.5732,
    width: 20.1728,
    height: 17.466,
    rx: 1,
    fill: "#E7E6F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M177.796 64.7108H180.485V71.7721C180.485 72.3244 180.038 72.7721 179.485 72.7721H178.796C178.243 72.7721 177.796 72.3243 177.796 71.7721V64.7108Z",
    fill: "#E7E6F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M177.796 64.7108H180.485V66.7629L177.796 65.4193L177.796 64.7108Z",
    fill: "#ABA9C8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.089 52.6189C173.089 52.2479 173.389 51.9471 173.76 51.9471H174.433V53.2907H173.76C173.389 53.2907 173.089 52.9899 173.089 52.6189V52.6189Z",
    fill: "#4841A6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M174.434 61.3796H177.123V61.7231C177.123 62.2754 176.676 62.7231 176.123 62.7231H175.434C174.881 62.7231 174.434 62.2754 174.434 61.7232V61.3796Z",
    fill: "#4841A6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M181.158 61.3796H183.848V61.7231C183.848 62.2754 183.4 62.7231 182.848 62.7231H182.158C181.606 62.7231 181.158 62.2754 181.158 61.7232V61.3796Z",
    fill: "#4841A6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M181.158 61.3796H183.848V62.052L181.158 61.3796Z",
    fill: "#353071"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M174.434 61.3796H177.123V62.052L174.434 61.3796Z",
    fill: "#353071"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M185.192 52.6189C185.192 52.2479 184.892 51.9471 184.521 51.9471H183.848V53.2907H184.521C184.892 53.2907 185.192 52.9899 185.192 52.6189V52.6189Z",
    fill: "#4841A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173.761,
    y: 50.6312,
    width: 10.7588,
    height: 10.7483,
    rx: 1,
    fill: "#8F87F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174.434,
    y: 51.3029,
    width: 9.41396,
    height: 5.37417,
    rx: 1,
    fill: "#E7E6F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M175.062 51.3029H182.85C183.402 51.3029 183.85 51.7507 183.85 52.3029V54.6575L175.607 51.3029H175.062Z",
    fill: "#ABA9C8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.778,
    cy: 58.6651,
    rx: 1.34485,
    ry: 1.34354,
    fill: "#E7E6F0"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.503,
    cy: 58.6651,
    rx: 1.34485,
    ry: 1.34354,
    fill: "#E7E6F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M179.141 53.9904L179.142 56.6775",
    stroke: "#8F87F3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.373 177.389C241.482 177.218 241.642 177.084 241.828 177.003C251.757 172.699 258.703 162.811 258.703 151.301C258.703 135.837 246.167 123.301 230.703 123.301C215.239 123.301 202.703 135.837 202.703 151.301C202.703 163.134 210.043 173.253 220.419 177.352C220.619 177.431 220.79 177.569 220.906 177.75L229.338 190.973C230.124 192.205 231.924 192.205 232.71 190.973L241.373 177.389Z",
    fill: "#5746C0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.829,
    cy: 151.427,
    r: 23.5622,
    fill: "#1A113C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M219.051 150.24V155.659L232.248 162.921V157.502L219.051 150.24Z",
    fill: "#8F87F3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M219.051 144.844V150.263L232.248 157.526V152.107L219.051 144.844Z",
    fill: "#8F87F3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M229.451 139.877L219.005 144.942L232.201 152.204L242.654 147.175L229.451 139.877Z",
    fill: "#8F87F3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3141_12046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3141_12046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 142,
    width: 10,
    height: 6
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M228.895 147.699L224.312 144.726L228.616 142.032L233.199 145.005L228.895 147.699Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.461 145.698C229.375 145.752 229.23 145.748 229.137 145.688C229.045 145.628 229.041 145.536 229.127 145.482C229.213 145.428 229.358 145.432 229.451 145.492C229.544 145.552 229.548 145.644 229.461 145.698ZM227.026 145.378C226.743 145.158 226.746 144.847 227.044 144.661C227.362 144.464 227.892 144.482 228.23 144.702L228.449 144.842C228.786 145.062 228.802 145.401 228.484 145.599C228.379 145.664 228.253 145.704 228.117 145.724L228.601 146.037C228.686 146.092 228.689 146.176 228.612 146.226C228.534 146.275 228.399 146.271 228.316 146.216L227.3 145.558L227.292 145.552L227.578 145.373L227.588 145.379C227.756 145.487 228.022 145.497 228.18 145.399C228.18 145.399 228.18 145.399 228.181 145.399C228.34 145.3 228.329 145.132 228.162 145.022L227.943 144.881C227.776 144.771 227.509 144.762 227.351 144.86C227.351 144.86 227.351 144.86 227.35 144.86C227.212 144.947 227.202 145.09 227.316 145.196L227.026 145.378ZM228.384 144.527C228.101 144.308 228.103 143.997 228.403 143.811C228.721 143.614 229.25 143.632 229.588 143.851L229.807 143.993C230.144 144.213 230.16 144.551 229.843 144.748C229.739 144.813 229.612 144.854 229.478 144.873L229.962 145.187C230.046 145.242 230.05 145.326 229.971 145.375C229.892 145.425 229.76 145.421 229.675 145.366L228.65 144.7L228.937 144.521L228.947 144.527C229.114 144.637 229.38 144.645 229.539 144.548C229.539 144.548 229.539 144.548 229.54 144.548C229.699 144.448 229.689 144.28 229.522 144.171L229.302 144.03C229.135 143.921 228.868 143.911 228.71 144.01C228.71 144.01 228.71 144.01 228.709 144.01C228.571 144.096 228.562 144.239 228.675 144.346L228.386 144.527M226.466 143.378C225.278 144.123 225.34 145.391 226.606 146.212C227.871 147.034 229.861 147.096 231.049 146.352C232.238 145.607 232.175 144.339 230.91 143.517C229.645 142.696 227.655 142.634 226.466 143.378Z",
    fill: "#E7E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.301 145.558L228.317 146.216C228.401 146.271 228.534 146.275 228.613 146.226C228.692 146.176 228.687 146.092 228.602 146.037L228.118 145.724C227.841 145.762 227.527 145.706 227.3 145.558M227.577 145.373L227.291 145.552L227.299 145.558L227.585 145.379L227.576 145.373",
    fill: "#ABA9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.935 144.523L228.649 144.702L229.674 145.367C229.758 145.422 229.891 145.426 229.97 145.377C230.049 145.327 230.045 145.242 229.96 145.188L229.476 144.875C229.198 144.913 228.884 144.857 228.657 144.709L228.944 144.53L228.933 144.524",
    fill: "#ABA9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.128 145.482C229.042 145.536 229.046 145.629 229.139 145.688C229.231 145.746 229.375 145.752 229.462 145.698C229.55 145.644 229.545 145.552 229.452 145.492C229.359 145.432 229.215 145.428 229.128 145.482Z",
    fill: "#4841A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.046 144.661C226.746 144.847 226.743 145.158 227.027 145.378L227.317 145.196C227.202 145.09 227.212 144.948 227.351 144.86C227.351 144.86 227.351 144.86 227.352 144.86C227.511 144.762 227.777 144.771 227.944 144.881L228.163 145.022C228.331 145.132 228.34 145.3 228.182 145.399C228.182 145.399 228.182 145.399 228.181 145.399C228.023 145.497 227.757 145.488 227.589 145.379L227.302 145.557C227.53 145.704 227.843 145.761 228.121 145.722C228.256 145.703 228.383 145.662 228.487 145.597C228.805 145.399 228.789 145.062 228.453 144.841L228.233 144.7C227.895 144.481 227.366 144.461 227.048 144.66",
    fill: "#ABA9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.404 143.811C228.104 143.997 228.101 144.308 228.385 144.527L228.674 144.346C228.559 144.239 228.569 144.098 228.708 144.01C228.708 144.01 228.708 144.01 228.709 144.01C228.868 143.911 229.134 143.921 229.301 144.03L229.52 144.171C229.688 144.28 229.697 144.448 229.539 144.548C229.539 144.548 229.539 144.548 229.538 144.548C229.38 144.646 229.113 144.637 228.946 144.527L228.659 144.705C228.885 144.853 229.2 144.911 229.479 144.871C229.613 144.852 229.741 144.811 229.844 144.746C230.161 144.549 230.145 144.21 229.808 143.991L229.589 143.849C229.251 143.629 228.722 143.611 228.404 143.808",
    fill: "#ABA9C8"
  })))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M242.536 157.503V152.978L232.303 157.782V162.475L242.536 157.503Z",
    fill: "#ABA9C8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M242.532 152.203V147.678L232.303 152.39V157.082L242.532 152.203Z",
    fill: "#ABA9C8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.648 152.529V152.976L232.527 157.814V162.338L242.648 157.445V157.892L232.247 162.92V157.501L242.648 152.529Z",
    fill: "#4841A6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.648 147.174V147.621L232.527 152.459V156.983L242.648 152.09V152.537L232.247 157.565V152.146L242.648 147.174Z",
    fill: "#4841A6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.051 150.012L224.984 153.375C225.089 153.434 225.153 153.545 225.153 153.665V153.665C225.153 153.92 224.878 154.08 224.656 153.955L219.051 150.778L219.051 150.012Z",
    fill: "#4841A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3141_12046",
    x: 77.5127,
    y: 389.082,
    width: 39.9041,
    height: 19.4945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3141_12046",
    x: 191.333,
    y: 307.032,
    width: 49.1873,
    height: 81.5173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_3141_12046",
    x: 150.038,
    y: 196.987,
    width: 45.5937,
    height: 24.1332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3141_12046",
    x: 44.033,
    y: 82.3753,
    width: 83,
    height: 98.9997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3141_12046",
    x: 145.014,
    y: 27,
    width: 68,
    height: 80.5966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3141_12046",
    x: 194.703,
    y: 123.301,
    width: 64,
    height: 76.5966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3141_12046",
    x1: 164.348,
    y1: 268.958,
    x2: 156.056,
    y2: 221.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3141_12046",
    x1: 222.858,
    y1: 405.654,
    x2: 208.232,
    y2: 406.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B239F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6537C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3141_12046",
    x1: 93.5518,
    y1: 264.371,
    x2: 127.166,
    y2: 291.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48219A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6537C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3141_12046",
    x1: 201.731,
    y1: 399.67,
    x2: 202.207,
    y2: 402.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B239F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6537C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3141_12046",
    x1: 235.24,
    y1: 288.269,
    x2: 204.703,
    y2: 323.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#421B93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6638C8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3141_12046",
    x1: 133.12,
    y1: 216.913,
    x2: 138.103,
    y2: 228.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3141_12046",
    x1: 127.09,
    y1: 170.657,
    x2: 151.697,
    y2: 206.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3141_12046",
    x1: 183.288,
    y1: 198.276,
    x2: 172.176,
    y2: 204.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3141_12046",
    x1: 157.075,
    y1: 187.786,
    x2: 164.262,
    y2: 205.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3141_12046",
    x1: 144.121,
    y1: 346.007,
    x2: 148.361,
    y2: 394.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2BECF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3141_12046",
    x1: 167.218,
    y1: 342.75,
    x2: 175.105,
    y2: 401.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806FBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3141_12046",
    x1: 144.852,
    y1: 340.617,
    x2: 144.852,
    y2: 346.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC3E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A6D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3141_12046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88741,
    height: 6.51743,
    fill: "white",
    transform: "translate(224.312 141.607)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08IntroOnboard01);
export default __webpack_public_path__ + "static/media/08_intro_onboard_01.382368f297a7b582098322aac36036c8.svg";
export { ForwardRef as ReactComponent };